import { FACTORY_OPTION } from "~/pages/Editor/EditorServiceAuthorization/options";

export const SUB_OPTIONS = {
  services: ["Code", "Name", "Fact", "CertificationDate", "Compliance"],
  requiredTools: [
    "Number",
    "Name",
    "Total",
    "Model",
    "CheckedDate",
    "Compliance",
  ],
  toolsInsurance: [
    "Number",
    "NumberList",
    "NumberDetail",
    "Name",
    "Total",
    "Compliance",
  ],
  toolsMetrological: ["Number", "Name", "Total", "Compliance"],
  tools: [
    "Number",
    "Name",
    "Model",
    "Country",
    "Year",
    "Note",
    "Total",
    "Compliance",
  ],
  warehouses: ["Number", "Name", "Area", "Combine", "Compliance"],
  places: [
    "Number",
    "Name",
    "Area",
    // "GroupOne",
    "PlacesCombine",
    "Compliance",
  ],
  placePosts: ["Name", "Total", "Compliance"],

  personal: [
    // "Number",
    "Name",
    "id",
    "PersonName",
    "Position",
    "PositionStart",
    "StudyCertificateDate",
    "Files",
    "DocName",
    "Compliance",
  ],
  // personalAdditions: ["Number", "Name", "Image", "Compliance"],
  notes: ["Number", "Name", "Image", "Compliance"],
  tradePremises: [
    "Number",
    "Name",
    // "GroupOne",
    "Area",
    "Address",
    "Compliance",
  ],
};

export const NUMBER_OPTIONS = [
  "Compliance",
  "Fact",
  "FactContract",
  // "Combine",
  // "PlacesCombine",
];
